var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title)?_c('div',{staticClass:"d-none"},[_c('portal',{attrs:{"to":"aside-title"}},[_vm._v(_vm._s(_vm.title))]),_c('portal',{attrs:{"to":"aside-content"}},[_vm._t("default",null,null,_vm.$props)],2)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }